module.exports = __webpack_public_path__ + "img/elan.59017fc4.svg";